var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDosingFillingPumpOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "OFF",
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 70,
    viewBox: "0 0 50 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9856",
    "data-name": "Group 9856"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3892",
    "data-name": "Path 3892",
    d: "M2.72,40.256,0,37.5l2.16-2.19a6.975,6.975,0,0,1,4.99-2.1H32.41V0h3.85V37.115H7.15a3.185,3.185,0,0,0-2.27.95Z",
    fill: "#6a7084"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9869",
    "data-name": "Group 9869",
    transform: "translate(17.39 23.703)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9859",
    "data-name": "Group 9859",
    transform: "translate(12.55)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9857",
    "data-name": "Group 9857",
    transform: "translate(0.32 0.33)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4307",
    "data-name": "Rectangle 4307",
    width: 8.59,
    height: 7.501,
    fill: "#6a7084"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9858",
    "data-name": "Group 9858"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3893",
    "data-name": "Path 3893",
    d: "M38.53,24.35V31.2H30.58V24.35h7.95m.64-.65H29.94v8.151h9.23V23.7Z",
    transform: "translate(-29.94 -23.7)",
    fill: "#404041"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9862",
    "data-name": "Group 9862",
    transform: "translate(0 8.331)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9860",
    "data-name": "Group 9860",
    transform: "translate(0.32 0.33)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4308",
    "data-name": "Rectangle 4308",
    width: 5.52,
    height: 5.601,
    fill: "#6a7084"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9861",
    "data-name": "Group 9861"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3894",
    "data-name": "Path 3894",
    d: "M22.91,32.68v4.951H18.03V32.68h4.88m.64-.65H17.39v6.251h6.16V32.03Z",
    transform: "translate(-17.39 -32.03)",
    fill: "#404041"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9865",
    "data-name": "Group 9865",
    transform: "translate(5.4 7.381)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9863",
    "data-name": "Group 9863",
    transform: "translate(0.32 0.33)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4309",
    "data-name": "Rectangle 4309",
    width: 22.89,
    height: 8.511,
    fill: "#6a7084"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9864",
    "data-name": "Group 9864"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3895",
    "data-name": "Path 3895",
    d: "M45.68,31.73v7.861H23.43V31.73H45.68m.64-.65H22.79v9.161H46.32V31.08Z",
    transform: "translate(-22.79 -31.08)",
    fill: "#404041"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9868",
    "data-name": "Group 9868",
    transform: "translate(1.73 15.242)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9866",
    "data-name": "Group 9866",
    transform: "translate(0.31 0.33)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3896",
    "data-name": "Path 3896",
    d: "M25.44,69.674a4.986,4.986,0,0,1-4.94-5.011V44.731H19.43V39.27H49.67v5.461H48.6V64.664a4.979,4.979,0,0,1-4.94,5.011Z",
    transform: "translate(-19.43 -39.27)",
    fill: "#6a7084"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9867",
    "data-name": "Group 9867"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3897",
    "data-name": "Path 3897",
    d: "M49.36,39.59V44.4H48.29V64.664a4.648,4.648,0,0,1-4.62,4.681H25.44a4.655,4.655,0,0,1-4.62-4.681V44.411H19.75V39.6H49.36m.64-.66H19.12v6.111h1.07V64.664a5.3,5.3,0,0,0,5.26,5.331H43.68a5.3,5.3,0,0,0,5.26-5.331v-19.6H50V38.94Z",
    transform: "translate(-19.12 -38.94)",
    fill: "#404041"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDosingFillingPumpOff);
export default __webpack_public_path__ + "static/media/dosing_filling_pump_off.3a502a18ff8dc1220c675490a26eae63.svg";
export { ForwardRef as ReactComponent };